import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import {ArrowsMain} from "../../../app-constants";

function Insights(props) {
    return (
        <div className="tekrevol_insights p-100 pb-0">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={10} lg={10} xl={8} xxl={8}>
                        <div className="example" data-text="Publications">
                            <h2>Insights</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tekrevol_insights_item">
                        <div className="blog_section">
                            <div className="blog_list">
                                <div className="blog_title">
                                    <Link
                                        href="/blogs/asim-rais-siddiquis-article-on-the-value-of-an-interconnected-organizational-culture-is-live-now-on-entrepreneur/"
                                        aria-label="View Blog">
                                        <h3>Asim Rais Siddiqui’s Article on the Value of an Interconnected
                                            Organizational Culture is Live Now on Entrepreneur</h3>
                                    </Link>
                                </div>
                                <div className="dates"> April 7, 2023</div>
                            </div>
                            <div className="blog_list">
                                <div className="blog_title">
                                    <Link href="/blogs/dara-the-future-of-home-care-app/"
                                          aria-label="View Blog">
                                        <h3>DARA – The Future of Home Care, App: A Revolutionary Solution by
                                            TekRevol</h3>
                                    </Link>
                                </div>
                                <div className="dates">April 7, 2023</div>
                            </div>
                            <div className="blog_list">
                                <div className="blog_title">
                                    <Link
                                        href="/blogs/world-down-syndrome-day/"
                                        aria-label="View Blog">
                                        <h3>Visit to KDSP on World Down Syndrome Day</h3>
                                    </Link>
                                </div>
                                <div className="dates">April 7, 2023</div>
                            </div>
                            <div className="blog_list">
                                <div className="blog_title">
                                    <Link
                                        href="/blogs/features-should-an-ideal-real-estate-mobile-app-must-have/"
                                        aria-label="View Blog">
                                        <h3>What Features Should an Ideal Real Estate Mobile App Must Have?</h3>
                                    </Link>
                                </div>
                                <div className="dates">April 4, 2023</div>
                            </div>
                            <div className="blog_list">
                                <div className="blog_title">
                                    <Link
                                        href="/blogs/10-trending-mobile-app-ideas-for-uae-business-owners-in-2023/"
                                        aria-label="View Blog" >
                                        <h3>10 Trending Mobile App Ideas for UAE Business Owners in 2023</h3>
                                    </Link>
                                </div>
                                <div className="dates">April 5, 2023</div>
                            </div>
                            <div className="blog_list">
                                <div className="blog_title">
                                    <Link href="/blogs/cost-to-make-an-app-like-instagram/"
                                          aria-label="View Blog">
                                        <h3>How Much Does It Cost to Make an App Like Instagram</h3>
                                    </Link>
                                </div>
                                <div className="dates"> March 31, 2023</div>
                            </div>
                        </div>
                        <div className="btn_load_all">
                            <Link href="/blogs" aria-label="View All Blogs">{ArrowsMain} </Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Insights;